import { render } from "./EclipseBackground.vue?vue&type=template&id=3ecb5ba0"
import script from "./EclipseBackground.vue?vue&type=script&lang=js"
export * from "./EclipseBackground.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__